import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';

import { SvgIcon, TableData } from '@make-software/cspr-design';

const StyledTableData = styled(TableData)(({ theme }) => ({
  width: 16,
  color: theme.styleguideColors.contentTertiary,
  'tr:hover &': {
    color: theme.styleguideColors.contentRed,
  },
}));

/* eslint-disable-next-line */
export interface TableDataLinkProps {
  iconSrc: string;
  onClick?: MouseEventHandler<HTMLTableDataCellElement>;
}

export function TableDataLink({ iconSrc, ...props }: TableDataLinkProps) {
  return (
    <StyledTableData {...props}>
      <SvgIcon src={iconSrc} role={'img'} />
    </StyledTableData>
  );
}

export default TableDataLink;
